// Data-saver switch for D1's free-tier daily read budget. While true, the
// read-heavy conveniences skip their queries so the budget goes to core
// inventory work: the dashboard aggregates, sidebar counts, product stat
// cards, and the Kanban board are paused. Core flows (product list, detail,
// search, exports, imports) are untouched.
// Flip to false and redeploy web to restore everything.
export const LOW_DATA_MODE = false;
